import React from "react";
import { useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";
import moment from "moment";
import momentTz from "moment-timezone";
import "bootstrap/dist/css/bootstrap.min.css";
import TaskOverview from "../../components/TaskOverview/TaskOverview";
import TimeView from "../../components/TimeView/TimeView";

function DayOverview(props) {
  const { currentTask, candidateId } = props;
  const { taskList, selectedDay, monthTimeline } = useSelector(
    (state) => state.candidateSlice
  );
  const { sessionUser: { timezone } } = useSelector((state) => state.sessionSlice);
  
  // Use timezone-aware parsing instead of string manipulation
  const selectedDayMoment = momentTz(selectedDay).tz(timezone);
  const momentDate = selectedDayMoment.date();
  const momentMonth = selectedDayMoment.month();
  const momentYear = selectedDayMoment.year();
  
  const today = selectedDayMoment.format("dddd, MMMM DD");
  
  console.log(momentDate, momentYear, momentMonth, "today")
  console.log(today, "today")
  console.log("selected day :- ", selectedDayMoment.format('YYYY-MM-DD'));

  const todayIndex = monthTimeline.findIndex(
    (val) => val.day === momentDate
  );

  // Safety check: if day not found in monthTimeline, default to 0 duration
  const receivedTotalWorkduration = todayIndex !== -1 ? monthTimeline[todayIndex].duration : 0;

  return (
    <Row className="my-4">
      <Col sm="4" className="text-center">
        <TimeView today={today} totalWorkDuration={receivedTotalWorkduration} candidateId={candidateId} />
      </Col>
      <Col sm="8" className="text-center">
        <TaskOverview
          taskList={taskList}
          currentTask={currentTask}
          totalWorkDuration={receivedTotalWorkduration}
        />
      </Col>
    </Row>
  );
}

export default DayOverview;
